/**
 * What kind of switch a flag is. The kind only drives how the admin groups and
 * explains flags; resolution treats every kind the same way.
 */
export enum FeatureFlagKind {
  /** Shipped feature. On by default, switched off per org when something misbehaves. */
  RELEASE = "release",
  /** Early feature. Off by default, orgs opt in one at a time. */
  BETA = "beta",
  /** Plan-level feature. Off unless a plan or a manual override grants it. */
  ENTITLEMENT = "entitlement",
  /** Operational switch. Flipped during incidents, not for product reasons. */
  OPS = "ops",
}
